<template>
    <div>
        <div class="logistics-banner" :style="{backgroundImage: 'url(' + (COMMON.isMobile ? mobileImg : img) + ')'}" v-if="!COMMON.isMobile">
        </div>
        <div class="logistics-banner-mobile" v-else><img :src="COMMON.isMobile ? mobileImg:img"/></div>
        <Tabs :innerMenu="innerMenu"></Tabs>
        <router-view></router-view>
    </div>
</template>
<style lang="less">
@import url(../style/logistics.less);
</style>
<script>
import Tabs from '../components/common/tabs';
export default {
    name: 'innovation',
    data() {
        return {
            img: '',
            mobileImg: '',
            title: '仓配一体',
            subTitle: '',
            innerMenu: [
                {
                    isCur: true,
                    name: 'in-one',
                    title: '仓配一体'
                },
                {
                    isCur: false,
                    name: 'city-wide',
                    title: '同城配送'
                },
                {
                    isCur: false,
                    name: 'e-commerce',
                    title: '电商物流'
                }
            ]
        };
    },
    methods: {
        getRoute() {
            this.img = require('../images/picture/banner/' + this.$route.name + '.jpg');
            this.mobileImg = require('../images/picture/banner/' + this.$route.name + '-mobile.jpg');
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        this.getRoute();
    },
    watch: {
        $route: function() {
            this.getRoute();
        }
    },
    components: {
        Tabs
    }
};
</script>